import classnames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import InboxIcon from 'components/lib/icons/inbox_icon';
import ProfileAvatar from 'components/lib/profile_avatar';
import SelectGroups from 'components/lib/select_groups';

export default class Assignment extends Component {
  focus() {
    this.select.focus();
  }

  renderLabel() {
    if (this.props.label) {
      return <label className="conversationAssignment-label">{this.props.label}</label>;
    }
  }

  renderIcon() {
    if (this.props.conversationAssignment) {
      return this.props.avatarProfile ? (
        <ProfileAvatar profile={this.props.avatarProfile} />
      ) : (
        <div className="conversationAssignment-inboxIconContainer">
          <InboxIcon className="conversationAssignment-inboxIcon" />
        </div>
      );
    }
  }

  render() {
    const {
      assignedGroupId,
      assignedAgentId,
      conversationAssignment,
      dropDown,
      isClosedConversation,
      isDisabled,
      isInline,
      onAssigneeChange,
      onFocus,
      options,
    } = this.props;
    let assignee = assignedGroupId;
    if (assignedAgentId) {
      assignee = `${assignedGroupId}${assignedAgentId}`;
    }
    let classNames = classnames('conversationAssignment-select select-wrapper assign-wrapper', {
      'is-disabled': isDisabled,
      isClosedConversation,
    });
    return (
      <div className={classnames('conversationAssignment', this.props.className)}>
        <div
          className={classnames('conversationAssignment-assignee', this.props.assignmentClassName, {
            'conversationAssignment-assignee-dropUp': !dropDown,
            'conversationAssignment-assignee-dropDown': dropDown,
            'conversationAssignment-assignee-inline': isInline,
          })}
        >
          {this.renderIcon()}
          <div
            className={classnames('conversationAssignment-assignee-menu', {
              'conversationAssignment-customerProfile': conversationAssignment,
            })}
          >
            {this.renderLabel()}
            <div className={classNames}>
              <SelectGroups
                backspaceRemoves={false}
                className="assignee"
                clearable={false}
                disabled={isDisabled}
                name="assignee"
                noResultsText="No results found"
                onChange={onAssigneeChange}
                onFocus={onFocus}
                options={options}
                placeholder="Not assigned"
                searchPromptText="Type teammate or inbox"
                value={assignee}
                ref={select => {
                  this.select = select;
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Assignment.propTypes = {
  assignedAgentId: PropTypes.string,
  assignedGroupId: PropTypes.string,
  assignmentClassName: PropTypes.string,
  avatarProfile: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.string,
  }),
  className: PropTypes.string,
  conversationAssignment: PropTypes.bool,
  dropDown: PropTypes.bool,
  isClosedConversation: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isInline: PropTypes.bool,
  label: PropTypes.string,
  onAssigneeChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  options: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/assignment.jsx